import React, { useMemo } from 'react';
import { dataHooks } from '@wix/data-hooks';
import { DeliveryMethodsSection } from '../../types';
import { useDeliverySectionData } from '../../provider/useDeliverySectionContext';
import { DeliveryOptionsGroup } from './DeliveryOptionsGroup';
import { UnsupportedShippingDestinationError } from '../ErrorComponents/UnsupportedShippingDestinationError';
import { Violations } from './Violations/Violations';
import { useLocaleKeys } from '../../locale-keys/LocaleKeys';
export const DeliveryOptionsPickerHooks = dataHooks('DeliveryOptionsPicker');
export const DeliveryOptionsPicker = props => {
  var _deliveries$pickupMet2, _deliveries$deliveryM2;
  const {
    shouldHideHeaders: shouldHideHeadersProp
  } = props;
  const {
    deliveries,
    shouldShowOnlyPickup,
    canShipToDestination
  } = useDeliverySectionData();
  const localeKeys = useLocaleKeys();
  const shouldHideHeaders = useMemo(() => {
    var _deliveries$pickupMet, _deliveries$deliveryM;
    if (shouldShowOnlyPickup) {
      return !!shouldHideHeadersProp;
    }
    const isOnlyOneType = (deliveries == null || (_deliveries$pickupMet = deliveries.pickupMethods) == null ? void 0 : _deliveries$pickupMet.length) === 0 || (deliveries == null || (_deliveries$deliveryM = deliveries.deliveryMethods) == null ? void 0 : _deliveries$deliveryM.length) === 0;
    return isOnlyOneType;
  }, [shouldShowOnlyPickup, shouldHideHeadersProp, deliveries == null || (_deliveries$pickupMet2 = deliveries.pickupMethods) == null ? void 0 : _deliveries$pickupMet2.length, deliveries == null || (_deliveries$deliveryM2 = deliveries.deliveryMethods) == null ? void 0 : _deliveries$deliveryM2.length]);
  if (!canShipToDestination) {
    return /*#__PURE__*/React.createElement(UnsupportedShippingDestinationError, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": DeliveryOptionsPickerHooks.root()
  }, !shouldShowOnlyPickup && /*#__PURE__*/React.createElement(DeliveryOptionsGroup, {
    title: localeKeys.deliverySection.shippingAndDelivery.header(),
    shouldHideHeaders: shouldHideHeaders,
    key: DeliveryMethodsSection.DELIVERY,
    type: DeliveryMethodsSection.DELIVERY,
    deliveryOptions: deliveries.deliveryMethods
  }), /*#__PURE__*/React.createElement(DeliveryOptionsGroup, {
    title: localeKeys.deliverySection.pickup.label(),
    shouldHideHeaders: shouldHideHeaders,
    key: DeliveryMethodsSection.PICKUP,
    type: DeliveryMethodsSection.PICKUP,
    deliveryOptions: deliveries.pickupMethods
  }), /*#__PURE__*/React.createElement(Violations, null));
};
//# sourceMappingURL=DeliveryOptionsPicker.js.map